import * as React from 'react';
import { clsx } from 'clsx';

import { CollapsedBlock } from '../CollapsedBlock';
import { trackOpenNewbuildingDescription } from './tracking';
import * as styles from './styles.css';
import { useDeviceType } from '@cian/ui-kit';
import DOMPurify from 'isomorphic-dompurify';

interface IDeveloperDescriptionProps {
  description: string;
}

export function DeveloperDescription({ description }: IDeveloperDescriptionProps) {
  // Описание в виде HTML должно поддерживаться для кастомизации, вставлять ссылки и т.д.
  // Но в то же время нужно избегать XSS атак, поэтому используем sanitize
  const sanitizedDescription = React.useMemo(() => DOMPurify.sanitize(description), [description]);

  const [opened, setOpened] = React.useState(false);
  const onChangeOpen = React.useCallback(
    (isOpen: boolean) => {
      setOpened(isOpen);
      if (isOpen) {
        setTimeout(trackOpenNewbuildingDescription, 0);
      }
    },
    [setOpened],
  );
  const deviceType = useDeviceType();

  const collapsedHeight = React.useMemo(() => {
    return deviceType === 'desktop' ? 154 : 88;
  }, [deviceType]);

  return (
    <CollapsedBlock opened={opened} onChangeOpen={onChangeOpen} collapsedHeight={collapsedHeight}>
      <span
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: sanitizedDescription }}
        className={clsx(styles['text'], opened && styles['formatted'])}
      />
    </CollapsedBlock>
  );
}
